var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 24,
    height: 24,
    transform: "translate(0.333)",
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_",
    "data-name": "g+",
    transform: "translate(-0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0.246 4.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M437.675,288.255v.072h-2.626v2.627H433v-2.627h-2.62v-2.048H433v-2.624h2.052v2.624h2.626v1.976Z",
    transform: "translate(-413.921 -280.167)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M425.392,285.515a8.087,8.087,0,0,1-1.287,6.345,6.6,6.6,0,0,1-3.706,2.43,8.078,8.078,0,0,1-2.464.241,7.3,7.3,0,0,1-4.01-1.419,7.446,7.446,0,0,1-2.945-4.5,7.033,7.033,0,0,1-.156-2.021,7.547,7.547,0,0,1,5.693-6.871,6.2,6.2,0,0,1,1.243-.193c.24-.009.48-.028.721-.021a7.093,7.093,0,0,1,3.561.97,8.8,8.8,0,0,1,1.333.98c-.733.741-1.456,1.463-2.183,2.192a4.044,4.044,0,0,0-2.211-1.065,4.439,4.439,0,0,0-4.946,3.455,4.232,4.232,0,0,0-.091,1.367,4.442,4.442,0,0,0,4.733,4.1,4.291,4.291,0,0,0,2.182-.708,3.424,3.424,0,0,0,1.484-2.263h-4.032v-2.9a.65.65,0,0,1,.008-.124Z",
    transform: "translate(-410.809 -279.507)",
    fill: "#5e5e5e"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGGray);
export default __webpack_public_path__ + "static/media/g+Gray.3355d94ef39d6cee96e76afcfd7de742.svg";
export { ForwardRef as ReactComponent };